import { useEffect } from "react";
import { trackFunnel, type FunnelEventName } from "@shared/utils/analytics";
import { AuthStore } from "@infrastructure/stores/auth.store";

/**
 * Отметить шаг воронки при открытии экрана.
 *
 * Событие уходит один раз на монтирование: воронка считает участников, а не показы,
 * поэтому повторный рендер того же экрана не должен добавлять событие.
 */
export function useFunnelStep(name: FunnelEventName, props?: Record<string, unknown>): void {
  useEffect(() => {
    trackFunnel(name, AuthStore.user?.id ?? null, props);
    // props намеренно не в зависимостях: объект пересоздаётся на каждый рендер.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);
}
